<template>
  <div id="VehicleList">
      <div :class="`loader${loaderClass}`" v-show="loading"></div>
          <div class="admin-page-content pending-reservation-lists">
              <!-- Button for Clear Cache -->
              <div class="btn-groups text-right">
                <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()" v-if="canExportReservation">
                      <i class="fp-export"></i> Export
                </a>
                <a href="javascript:void(0)" v-on:click="makeReservationNew()" v-if="canMakeReservation" v-bind:to="{ path:'/reservation/create'}" class='btn btn-primary'>
                  <i class="fp-calendar"></i>  Add Reservation
                </a>
              </div>
              <data-table-filter-config :moduleName="'pendingReservationList'" ref="filterTempReservation" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
              <div class="data-table bg-white overflow-hidden">
                <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                <section class="bg-white data-table">
                    <custom-pagination
                        :page-changed="onPageChange"
                        :per-page-changed="onPerPageChange" :moduleName="'pendingReservationList'" :position="'top'">
                    </custom-pagination>

                    <vue-good-table
                            mode="remote"
                            ref="listPendingReservations"
                            title="Reservations"
                            @on-page-change="onPageChange"
                            @on-sort-change="onSortChange"
                            @on-selected-rows-change="selectionChanged"
                            @on-column-filter="onColumnFilter"
                            @on-per-page-change="onPerPageChange"
                            @on-select-all="onSelectAll"
                            :totalRows="totalRecords"
                            :columns="userColumns"
                            :rows="rows"
                            :isLoading=false
                            :paginationOptions="{
                                                      enabled: false,
                                                      position: 'both',
                                                      perPage: perPage,
                                                      perPageDropdown:dropDownPerPage,
                                                      setCurrentPage:listCurrentPage,
                                                      dropdownAllowAll: false

                                                  }"
                            @on-cell-click="selectAction"
                            :search-options="{
                                                  enabled: false,
                                                  }"
                            :sort-options="{
                                                  enabled: true,
                                                  }"
                            :select-options="{
                              enabled: true,
                              selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                              selectionInfoClass: 'custom-class',
                              selectionText: 'rows selected',
                              clearSelectionText: 'clear',
                            }"
                    >
                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                        <div :key="key">
                            <div v-if="props.column.field == 'reference_no'">
                                <a class="color-blue" href="javascript:void(0)" v-on:click="selectAction(props.row.temp_booking_id ,props.row.temp_reservation_id ,flag='view')" title="View Pending Reservation">
                                {{props.row.reference_no}}
                                </a>
                            </div>
                            <div v-else>
                                {{props.formattedRow[props.column.field]}}
                            </div>
                        </div>
                    </template>
                    <div slot="selected-row-actions">
                        <button v-if="canMakeReservation" id="make_reservation" class="btn btn-primary" v-on:click.prevent="makeReservation"> <i class="fp-calendar"> </i> Add Reservation </button>
                        <button v-if="deleteRes == true"  id="deleteTempReservationBtn" v-on:click.prevent="deleteTempReservation" class="btn btn-secondary">Cancel</button>
                    </div>
                  </vue-good-table>
                  <custom-pagination
                      :page-changed="onPageChange"
                      :per-page-changed="onPerPageChange">
                  </custom-pagination>
                </section>
              </div>
          </div>
          <div class="modal fade invoice-modal" id="reservation_modal" ref="resModal" data-backdrop="static" data-keyboard="false" aria-labelledby="resModal" aria-hidden="true">
              <div class="modal-dialog modal-lg" role="document">
                  <div class="modal-content">
                      <div class="modal-header">
                          <h5 class="modal-title">Reservation List</h5>
                      </div>
                      <div class="modal-body">
                          <div :class="`loader${loaderClass}`" v-show="resEnrichloading"></div>
                          <input type="hidden" v-model="reservQty">
                          <div v-if="enrichResArr.length > 0" class="enrich-transition-number top-enrich-section">
                              <span class="current-statis-fp">Flexible Date:</span><span>&nbsp;{{flexDate}}</span>
                              <div style="clear: both"></div>
                              <span class="current-statis-fp">Flexible Location:</span><span>&nbsp;{{flexLocation}}</span>
                          </div>
                          <table aria-describedby="table" class="table table-sm">
                              <thead>
                                <tr class="table-primary">
                                    <th><input type="checkbox" v-model="allSelected" @click="selectAllRes" value="all" /></th>
                                    <th>Reservation#</th>
                                    <th>Truck Type</th>
                                    <th>Location From</th>
                                    <th>Location To</th>
                                    <th>Unit#</th>
                                    <th>Status</th>
                                    <th>From Date</th>
                                    <th>To Date</th>
                                    <th>Customer</th>
                                </tr>
                              </thead>
                              <tbody>
                                <template v-if="enrichResArr.length > 0">
                                    <tr :key="'res'+resKey" v-for="(res,resKey) in enrichResArr">
                                        <td><input type="checkbox" v-model="enrichRes" @change="selectRes(res)" :value="res"></td>
                                        <td>{{ res.reference_no }}</td>
                                        <td>{{ res.vehicle_type }}</td>
                                        <td>{{ res.location_from_name }}</td>
                                        <td>{{ res.location_to_name }}</td>
                                        <td>{{ res.unit_no }}</td>
                                        <td>{{ res.status }}</td>
                                        <td>{{ res.pickup_time }}</td>
                                        <td>{{ res.dropoff_time }}</td>
                                        <td>{{ res.customer_name }}</td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr><td colspan="10">No reservation found.</td></tr>
                                </template>
                              </tbody>
                          </table>
                          <template v-if="dataNotFound.length > 0">
                              <span class="error hide">Following details not found in to the system, Please sync it from Enrich.</span>
                              <table aria-describedby="table" class="table table-sm">
                                  <thead>
                                    <tr class="table-primary">
                                        <th>Unit#</th>
                                        <th>Message</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr :key="'notFound'+notKey" v-for="(notFound,notKey) in dataNotFound">
                                        <td>{{ notFound.unit_no }}</td>
                                        <td>{{ notFound.message }}</td>
                                    </tr>
                                  </tbody>
                              </table>
                          </template>
                          <span class="field-error">{{ enrichDataMsg }}</span>
                      </div>
                      <div class="modal-footer">
                          <button class="btn btn-primary" id="sync_btn" v-on:click="mapReservation()">Sync</button>
                          <button type="button" class="btn btn-tertiary" data-dismiss="modal">Cancel</button>
                      </div>
                  </div>
              </div>
          </div>
      </div>
</template>
<script>
import EventBus from ".././event-bus";
import Vue from "vue";
import { commonMixins } from "../../mixins/commonMixins";
import {dataTableMixins} from '../../mixins/dataTableMixins';

import { locale } from 'moment';

export default {
  name: "listPendingBooking",
  mixins: [commonMixins,dataTableMixins],

  props: {
      reservationVal: {
          type: Array,
          required: true,
          default:undefined
      }
  },
  data: () => ({
    enrichDataMsg:"",
    selResId:"",
    enrichRes: [],
    selectedRes: [],
    allSelected: false,
    resEnrichloading:false,
    firstLoad: 0,
    userRole: "",
    reservQty:"",
    permissions: [],
    enrichResArr:[],
    dataNotFound:[],
    userColumns:[],
    columns: [
      {
        label: "#Reference",
        field: "reference_no",
        filterable: true,
        fpFieldType:"text",
        hidden:false,
        width: '90px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "#Reference", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Customer",
        field: "company",
        fpFieldType:"text",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Customer Name", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
        {
            label: "Asset Type",
            field: "assetType",
            fpFieldType:"option",
            filterable: true,
            hidden:false,
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Asset Type", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.onColumnFilter, //custom filter function that
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
        {
            label: "Qty",
            field: "quantity",
            width: '40px',
            fpFieldType:"text",
            filterable: true,
            hidden:false,
            type: "number",
            filterOptions: {
                enabled: false, // enable filter for this column
                placeholder: "Qty", // placeholder for filter input
                filterValue: "", // initial populated value for this filter
                filterDropdownItems: [], // dropdown (with selected values) instead of text input
                filterFn: this.onColumnFilter, //custom filter function that
                trigger: "enter" //only trigger on enter not on keyup
            }
        },
       {
           label: "Location",
           field: "location",
           filterable: true,
           fpFieldType:"option",
           hidden:false,
           filterOptions: {
               enabled: false, // enable filter for this column
               placeholder: "Filter", // placeholder for filter input
               filterValue: '', // initial populated value for this filter
               filterDropdownItems: [], // dropdown (with selected values) instead of text input
               filterFn: this.onColumnFilter, //custom filter function that
               trigger: "enter" //only trigger on enter not on keyup
           }

       },
      {
        label: "Is Completed",
        field: "complete_status",
        filterable: true,
        fpFieldType:"option",
        hidden:false,
        width: '120px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Complete Status", // placeholder for filter input
          filterValue: "All", // initial populated value for this filter
          filterDropdownItems: ["True", "False"], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Credit Status",
        field: "credit_status",
        filterable: false,
        sortable: false,
        fpFieldType:"option",
        hidden:false,
        width: '120px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Complete Status", // placeholder for filter input
          filterValue: "All", // initial populated value for this filter
          filterDropdownItems: ["Y", "N"], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Insurance Status",
        field: "insurance_status",
        filterable: false,
        sortable: false,
        fpFieldType:"option",
        hidden:false,
        width: '120px',
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "Complete Status", // placeholder for filter input
          filterValue: "All", // initial populated value for this filter
          filterDropdownItems: ["Y", "N"], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      // {
      //   label: "Stage",
      //   field: "user_stage",
      //   filterable: true,
      //   width: '120px',
      //   filterOptions: {
      //     enabled: true, // enable filter for this column
      //     placeholder: "Customer Stage", // placeholder for filter input
      //     filterValue: "All", // initial populated value for this filter
      //     filterDropdownItems: ["All", "Potential", "Account Pending", "Credit Denied", "New", "Existing"], // dropdown (with selected values) instead of text input
      //     filterFn: this.onColumnFilter, //custom filter function that
      //     trigger: "enter" //only trigger on enter not on keyup
      //   }
      // },
      {
        label: "Start Date",
        field: "pickup_datetime",
        filterable: true,
        fpFieldType:"date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "End Date",
        field: "dropoff_datetime",
        filterable: true,
        fpFieldType:"date",
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Created Date",
        field: "created_at",
        fpFieldType:"date",
        filterable: true,
        hidden:false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "MM/DD/YYYY", // placeholder for filter input
          filterValue: "", // initial populated value for this filter
          filterDropdownItems: [], // dropdown (with selected values) instead of text input
          filterFn: this.onColumnFilter, //custom filter function that
          trigger: "enter" //only trigger on enter not on keyup
        }
      },
      {
        label: "Total",
        field: "total",
        fpFieldType:"integer",
        width: '100px',
        type: "number",
        filterable: true,
        hidden:false,
//        sortable: false
      },
      // {
      //   label: "Actions",
      //   field: "action",
      //   html: true,
      //   hidden:false,
      //   sortable: false
      // }
    ],
    rows: [],
    totalRecords: 0,
    cancel_booking_id: 0,
    cancelvalue: "",
    loading: false,
    cantAccess: true,
    flag: "",
    flexLocation:"False",
    flexDate:"False",
    deleteRes:false,
    canMakeReservation: false,
    canExportReservation: false,
    deleteReason:{
      reason_id:0,
      reason:'',
    },
    action:'list',
    pageKey:"_pending_reservation_list_",
    batchProcess:0,
    batchNum:"",
  }),
  watch: {
    permissions: function(permission) {
      var self = this;
      permission.forEach(function(permissions) {
        if (permissions.name == "list_pending_reservation") {
          self.cantAccess = true;
        }
        if (permissions.name == "delete_pending_reservation") {
          self.deleteRes = true;
        }
        if (permissions.name == "make_reservation") {
          self.canMakeReservation = true;
        }
        if (permissions.name == "export_reservation") {
          self.canExportReservation = true;
        }

      });
      if (self.cantAccess == "") {
        self.cantAccess = false;
      }
    },
    '$route.path':function(val,oldval){
          var self = this;
          console.log(val);
          console.log(oldval);
          // this.mounted();

        setTimeout(function(){

          self.loadList();
        },100);
      },
  },

  mounted: function() {
    var self = this;

    //check user loggged in or not
    var userObj = localStorage.getItem("user_obj");

    //if user logged in than remove login button and registration button
    if (userObj != null) {
      var userJson = JSON.parse(userObj);
      if (userJson.roles.length > 0) {
        this.userRole = userJson.roles[0].name;
        this.loggedinUserId = userJson.id;
      }


    }

    if (this.userRole == "customer") {
      this.$router.push("/");
    }
    this.getPermissions();
    //this.loadList();
  },
  methods: {
      cancelAll: function (cancelAll) {
        this.$refs.listPendingReservations.unselectAllInternal();
      },
      selectionChanged(param) {
          var self = this;
          self.serverParams.selectedAll = false;
          if(param.selectedRows.length == 100) {
            EventBus.$emit('clear-selection', false);
          } else {
            EventBus.$emit('clear-all-flags', false);
          }
      },
      //select all enrich reservation for map
      selectAllRes: function () {

          if (!this.allSelected) {

              this.enrichRes = [];
              for (var res1 in this.enrichResArr) {
                  this.enrichRes.push(this.enrichResArr[res1]);
              }
          } else {
              this.enrichRes = [];
          }
            console.log(this.enrichRes);
      },

      //select enrich reservation for map
      selectRes: function (res) {

          var self = this;

          self.allSelected = false;
          //self.enrichRes.push(res);
          console.log(self.enrichRes);
      },

      //map Enrich reservation
      mapReservation: function () {

        var self = this;

        var message = "";
        if ( self.reservQty > self.enrichRes.length ) {
            message = "Reservation quantity is lesser than selected reservation";
        } else if ( self.reservQty < self.enrichRes.length ) {
            message = "Reservation quantity is greater than selected reservation";
        } else {
            message = "Are you sure you want to sync reservation?";
        }

          var resId = self.selResId

          this.$swal({
              title: message,
              text: "Do you wants to sync?",
              type: "warning",
              //input: "textarea",
              showCancelButton: true,
              confirmButtonText: "Confirm",
              cancelButtonText: "Close",
              showCloseButton: true,
              showLoaderOnConfirm: true
          }).then(result => {
              if (result.value) {

                  var resId = self.selResId

                  self.loading = true;
                  $("#sync_btn").prop("disabled",true);
                  $("#sync_btn").text("Syncing....");

                  $.ajax({
                      url: process.env.ROOT_API + "/map_enrich_reservation",
                      type: "post",
                      crossDomain: true,
                      dataType: "json",
                      data:{'resId':resId,'enrichRes':self.enrichRes},
                      headers: this.ajxHeaders,
                      success: function(data) {

                          self.loading = false;
                          $("#sync_btn").prop("disabled",false);
                          $("#sync_btn").text("Sync");
                          if (data.status == "success") {
                              alert("Reservation has been synced successfully.")
                              $('#reservation_modal').modal('hide');
                              self.loadList();
                          }
                      },
                      error: function(jqXHR, exception) {

                          self.loading = false;
                          $("#sync_btn").prop("disabled",false);
                          $("#sync_btn").text("Sync");

                          self.generateStatusCodeMessage(jqXHR,true,'map-reservation-panding')
                      }
                  });

              } else if (result.dismiss) {
                  // self.$router.push("/./listbookings");
              }
          });
      },

      //Syncing enrich reservation
      syncReservation: function (resId,qty) {

          var self = this;

          //clear previous data
          self.enrichResArr = [];
          self.dataNotFound = [];
          self.enrichDataMsg = "";

          //open modal to display reservation list
          $('#reservation_modal').modal('show');
          self.resEnrichloading = true;
          self.reservQty = qty;
          self.selResId = resId;


          $.ajax({
              url: process.env.ROOT_API + "/sync_enrich_reservation",
              type: "post",
              crossDomain: true,
              dataType: "json",
              data:{"reservationId":resId},
              headers: this.ajxHeaders,
              success: function(data) {
                  self.loading = false;
                  self.resEnrichloading = false;
                  if (data.status == "success") {

                      self.enrichResArr = data.content.reservationArr;
                      self.dataNotFound = data.content.notFoundArr;

                      if ( data.content.flexLocation == 1 ) {
                          self.flexLocation = "True";
                      }
                      if ( data.content.flexDate == 1 ) {
                          self.flexDate = "True";
                      }

                  } else {
                      self.enrichDataMsg = data.message;
                  }
              },
              error: function(jqXHR, exception) {
                  self.resEnrichloading = false;
                  self.loading = false;
                  self.generateStatusCodeMessage(jqXHR,true,'sync-enrich-reservation-panding')
              }
          });

      },
    //
    selectAction: function(temp_booking_id, temp_resevation_id, flag) {
      var self = this;
      if (flag == "view") {
        localStorage.setItem("temp_reservation_id", temp_resevation_id);
        if (self.reservationVal[1] == "unsyncbooking") {
          self.flag = "unsyncbooking";
        }
        self.$router.push({
              name: "PendingReservationContent",
              params: { id: temp_booking_id, flag: self.flag }
        });
        // self.$router.push("/viewbookings/" + id);
      }

      if (flag == "cancel") {
        self.cancel_booking_id = id;

        this.$swal({
          title: "Are you sure?",
          text: "Reason for cancellation",
          type: "warning",
          input: "textarea",
          showCancelButton: true,
          confirmButtonText: "Confirm",
          cancelButtonText: "Close",
          showCloseButton: true,
          showLoaderOnConfirm: true
        }).then(result => {
          if (result.value) {
            //getting comment value for reason of cancellation
            self.comment = JSON.stringify(result.value);

            $.ajax({
              url:
                process.env.API +
                "/" +
                process.env.VERSION +
                "/cancel_booking",
              type: "get",
              crossDomain: true,
              dataType: "json",
              headers: this.ajxHeaders,
              data: {
                id: self.cancel_booking_id,
                comment: self.comment,
                user_id: self.loggedinUserId
              },
              success: function(data) {
                //console.log(data.content[0]["id"]);
                if (data.status == "success") {
                  location.reload();
                  console.log(data.content);
                  self.loading = false;
                  // self.$router.push("/./listbookings");
                }
              },
              error: function(jqXHR, exception) {
                // self.$router.push("/./listbookings");
                  self.generateStatusCodeMessage(jqXHR,true,'cancle-reservation-panding')
              }
            });
          } else if (result.dismiss) {
            // self.$router.push("/./listbookings");
          }
        });
      }
      // }
    },

    exportCheck: function() {
        var count = 0;
        var actionFlag = "";
        var data = this.$refs['listPendingReservations'].selectedRows;
        count = data.length;
        if(this.serverParams.selectedAll == true){
            actionFlag = "";
        }else if(count != 0 && count <= 100){
            actionFlag = "export";
        }
        this.exportReports(actionFlag);
    },
    // // loadList is what brings back the rows from server
    loadList: function() {

      var data = this.$refs['listPendingReservations'].selectedRows;
      var self = this;
      var use = [];
      for (var i = 0; i < data.length; i++) {
        //take temp_reservation_id
        use.push(this.$refs['listPendingReservations'].selectedRows[i].temp_reservation_id)
      }

      var page = self.$route.path.split('/');
      var type = '';
      console.log(page[2]);
      if (page && page[2] == 'lease'){
          // self.title = 'Lease Reservation';
          type = 'lease';
      }else{
          // self.title = 'Rental Reservation';
          type = '';
      }

      if ( self.reservationVal[1] == "unsyncbooking" ) {
        self.flag = "unsyncbooking";
      }
      self.loading = true;

      var date = new Date();
      var offset = date.getTimezoneOffset();

      self.firstLoad = 1;

      $.ajax({
        url: process.env.ROOT_API + "/pending_list_bookings",
        type: "POST",
        crossDomain: true,
        headers: this.ajxHeaders,
        dataType: "json",
        data: {
          page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: this.serverParams.columnFilters,
          sort: this.serverParams.sort,
          offset: offset,
          flag: self.flag,
          type:type,
          reason_id:self.deleteReason.reason_id,
          id:use,
          reason:self.deleteReason.reason,
          action:self.action,
          all:self.serverParams.selectedAll,
        },
        success: function(data) {
          self.loading = false;
          //console.log(data.content[0]["id"]);
          if (data.status == "success") {

            if (self.action == 'delete'){
              self.action = 'list';
              self.$refs.filterTempReservation.clearSelectAll();
              EventBus.$emit('clear-all-flags', false);
              self.loadList();
            }else if(self.action == 'export' || self.action == 'export_queue'){
              if ( data.code == "201" ) {
                  alert(data.message);
              } else {
                  if ( self.action == "export" ) {
                      self.excel = data.content.web;
                      var save = document.createElement("a");
                      save.href = self.excel;
                      save.download = data.content.web;
                      save.target = "_blank";

                      document.body.appendChild(save);
                      save.click();
                      document.body.removeChild(save);

                  } else {

                      self.batchProcess = 1;
                      self.batchNum = data.content;
                  }
              }
              self.action = "list";
              self.loadList();
            }else{
              if (data.content.row != undefined) {
                self.rows = data.content.row;
              }

              self.totalRecords = data.content.totalRecords;

              //if list page load for the unsync customer
              if (self.reservationVal[1] == "unsyncbooking") {
                // EventBus.$emit("pastResCnt", data.content.customerCnt);
                // EventBus.$emit("currentResCnt", data.content.paymentCnt);
                EventBus.$emit("pendingReservationCount", data.content.pendingReservationCount);
                EventBus.$emit("pastReservationCount", data.content.pastReservationCount);
                EventBus.$emit("currentReservationCount", data.content.currentReservationCount);
              }
            }
          }
        },
        error: function(jqXHR, exception) {
          self.loading = false;

            self.generateStatusCodeMessage(jqXHR,true,'list-reservation-panding')
        }
      });
    },
    viewInvoice: function(id, flag) {
      var self = this;
      $("#invoice_modal .modal-body").html("");
      $("#invoice_modal").modal("show");
      this.loading = true;

      $.ajax({
        url:
          process.env.ROOT_API + "/download_invoice",
        type: "POST",
        crossDomain: true,

        headers: this.ajxHeaders,
        data: {
          booking_id: id,
          flag: flag
        },
        success: function(data) {
          self.loading = false;
          $("#invoice_modal .modal-body").html(data);
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'view-invoice-reservation-panding')
        }
      });
    },
    addTruck: function() {
      var self = this;

      localStorage.removeItem("booking_id");
      localStorage.removeItem("truck_id");
      localStorage.removeItem("truck_type");

      self.$router.push("/");
    },
    exportTempReservation: function() {
      var self = this;
      self.loading = true;
      var date = new Date();
      var offset = date.getTimezoneOffset();
      var page = self.$route.path.split('/');
      var type = '';
      console.log(page[2]);
      if (page && page[2] == 'lease'){
          // self.title = 'Lease Reservation';
          type = 'lease';
      }else{
          // self.title = 'Rental Reservation';
          type = '';
      }
      var data = this.$refs['listPendingReservations'].selectedRows;
      var use = [];
      for (var i = 0; i < data.length; i++) {
        //take temp_reservation_id
        use.push(this.$refs['listPendingReservations'].selectedRows[i].temp_reservation_id)
      }

      $.ajax({
        url:
          process.env.ROOT_API +
          "/pending_list_bookings",
        type: "POST",
        crossDomain: true,
        dataType: "json",
        headers: this.ajxHeaders,

        data: { page: self.serverParams.page,
          perPage: self.serverParams.perPage,
          filters: self.serverParams.columnFilters,
          sort: self.serverParams.sort,
          offset: offset,
          flag: self.flag,
          id:use,
          all:self.serverParams.selectedAll,
        for_export:'true',
        type:type },
        success: function(data) {
          self.loading = false;
          console.log(data);
          if ( data.code == 201) {
            alert(data.message);
          }else{
            self.excel = data.content.web;
            // var filename = data.content.filename;
            var save = document.createElement("a");
            save.href = self.excel;
            // save.setAttribute('download', 'Reservation');
            save.download = self.excel;
            save.target = "_blank";
            document.body.appendChild(save);
            save.click();
            document.body.removeChild(save);
            EventBus.$emit('clear-selection', false);
            self.cancelAll(true);
            self.loadList()
          }

          // $("#invoice_modal .modal-body").html(data);
        },
        error: function(jqXHR, exception) {
          self.loading = false;
            self.generateStatusCodeMessage(jqXHR,true,'export-temp-reservation-panding')
        }
      });
    },
    makeReservation() {

      var self = this;
      var page = self.$route.path.split('/');
      if ( this.$refs['listPendingReservations'].selectedRows.length != 1 ) {
        self.$swal('',"Please choose only one reservation.",'info');
        return;
      }
      var resId = this.$refs['listPendingReservations'].selectedRows[0].temp_reservation_id;
      var reference_no = this.$refs['listPendingReservations'].selectedRows[0].reference_no;
      var qty = this.$refs['listPendingReservations'].selectedRows[0].quantity;
      var data = this.$refs['listPendingReservations'].selectedRows[0].user_stage;
      var customer_id = this.$refs['listPendingReservations'].selectedRows[0].cust_id;
      var customer_name = this.$refs['listPendingReservations'].selectedRows[0].contact;
      var customer_number = this.$refs['listPendingReservations'].selectedRows[0].user_number;
      var location_id = this.$refs['listPendingReservations'].selectedRows[0].location_id;
      var location_name = this.$refs['listPendingReservations'].selectedRows[0].location_name;
      var location_code = this.$refs['listPendingReservations'].selectedRows[0].location_code;
      var pickup_date = this.$refs['listPendingReservations'].selectedRows[0].pickup_date;
      var pickup_time = this.$refs['listPendingReservations'].selectedRows[0].pickup_time;
      var dropoff_date = this.$refs['listPendingReservations'].selectedRows[0].dropoff_date;
      var dropoff_time = this.$refs['listPendingReservations'].selectedRows[0].dropoff_time;
      var asset_type = this.$refs['listPendingReservations'].selectedRows[0].assetType;
      var asset_type_id = this.$refs['listPendingReservations'].selectedRows[0].assetTypeId;
      var estimated_miles = this.$refs['listPendingReservations'].selectedRows[0].miles;

      if ( data != 'New' && data != 'Existing' ) {

        self.$swal('',"Sorry, customer's credit has not been approved yet.",'info');
      } else {

        //var string = "&for=from_pending_reseravtion_list"+"&customer_id="+customer_id+"&qty="+qty+"&reference_no="+reference_no+"&customer_name="+customer_name+"&customer_number="+customer_number+"&location_id="+location_id+"&location_name="+location_name+"&pickup_date="+pickup_date+"&pickup_time="+pickup_time+"&dropoff_date="+dropoff_date+"&dropoff_time="+dropoff_time+"&estimated_miles="+estimated_miles+"&asset_type_id="+asset_type_id+"&location_code="+location_code;
        var string = "&for=pendingReservation&resId="+resId+"&action=create&from="+page[2];
        this.$router.push({ name: 'MakeReservation', query: { data : btoa(string) }});

      }

    },
    makeReservationNew: function(){
        var page = this.$route.path.split('/');
        var type = '';
        console.log(page[2]);

        var string = "&from="+page[2]+"&url_type=pending";
        this.$router.push({ name: 'MakeReservation', query: { data : btoa(string) }});

    },
    deleteTempReservation(){
      var data = this.$refs['listPendingReservations'].selectedRows;
      var self = this;
      var use = [];
      for (var i = 0; i < data.length; i++) {
        //take temp_reservation_id
        use.push(this.$refs['listPendingReservations'].selectedRows[i].temp_reservation_id)
      }

      $.ajax({
          url: process.env.ROOT_API + "/get_reasons",
          type: "GET",
          crossDomain: true,
          headers: this.ajxHeaders,
          data: {module:'reservation'},
          dataType: "json",
          success: function (data) {
              //console.log(data.content[0]["id"]);
              var options = data;

              self.$swal({
                      title: "Are you sure?",
                      text: "Reason Of Remove",
                      type: "warning",
                      html:'<input type="textarea" id="swal-input1" class="swal2-input">',
                      // html:'<v-select :options="[text:"reservation",value:"reser"]"></v-select>',
                      input: "select",
                      inputOptions:options,
                      showCancelButton: true,
                      confirmButtonText: "Confirm",
                      cancelButtonText: "Close",
                      showCloseButton: true,
                      showLoaderOnConfirm: true,
                      preConfirm: function (value) {
                          // alert($("#swal-input1").val());
                          // var val = true;
                          return new Promise(function (resolve, reject) {
                          if(value == 0 && $("#swal-input1").val() == ''){
                              self.$swal.showValidationError(
                                  'Please Enter Reason.'
                              )
                              value = false;
                          }

                          resolve(value)
                          })
                      }
                  }).then(result => {
                      if($("#swal-input1").val() == ''){
                          $("#swal-input1").val("No Reason");
                  }

                  if (result.value) {

                      //getting comment value for reason of cancellation
                      var comment = $("#swal-input1").val();
                      console.log('hello there');
                      console.log(result.value);
                      var reason_id = result.value;
                      // alert(result.value);

                      self.loading = true;

                      self.deleteReason = {
                        reason:comment,reason_id:reason_id
                      };
                      self.action = 'delete';
                      self.loadList();
                      // $("#deleteTempReservationBtn").val("Deleting ...");
                      // $.ajax({
                      //   url: process.env.ROOT_API + "/pendingreservation/delete",
                      //   type: "POST",
                      //   data: {id:use,reason:comment,reason_id:reason_id},
                      //   headers: {
                      //     'Accept': 'application/json',
                      //     "Authorization": "Bearer " + localStorage.getItem("tkn"),
                      //     'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                      //     "Cache-Control": "no-cache"
                      //   },
                      //   dataType: 'json',
                      //   success: function (data) {
                      //     self.loading = false;
                      //     setTimeout(function () {
                      //     $(".alert-success").removeClass("show");
                      //       $(".alert-success").addClass("hide");
                      //     }, 10000);
                      //     setTimeout(function () {
                      //       $("#deleteTermBtn").val("Delete");
                      //     }, 10000);

                      //     if (data.code == '200') {
                      //       self.loadList();
                      //     }
                      //   },
                      //   error: function (jqXHR, exception) {
                      //     self.loading = false;
                      //       self.generateStatusCodeMessage(jqXHR,true,'delete-reservation-panding')
                      //   }
                      // });


                  } else if (result.dismiss) {
                      // self.$router.push("/./listbookings");
                  }
              });
          },
          error: function (jqXHR, exception) {
              self.generateStatusCodeMessage(jqXHR,true,'get-reason-reservation-panding')
          }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Reservation/PendingReservationList.vue